var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon add-icon",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon__mark add-icon__mark",
    d: "M87.87,42.6h-29.5V13.1c0-4.14-3.36-7.5-7.5-7.5s-7.5,3.36-7.5,7.5v29.5h-30.5c-4.14,0-7.5,3.36-7.5,7.5     s3.36,7.5,7.5,7.5h30.5v29.5c0,4.14,3.36,7.5,7.5,7.5s7.5-3.36,7.5-7.5V57.6h29.5c4.14,0,7.5-3.36,7.5-7.5S92.01,42.6,87.87,42.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon-add.bd248f51e64f44c0d03240fcb86b403e.svg";
export { ForwardRef as ReactComponent };